import React from 'react'
import AmenitiesPage from '../components/amenities/amenitiesPage'

const Amenities = () => {
    return (
        <div className='outletConainer'>
            <AmenitiesPage />
        </div>
    )
}

export default Amenities
